// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { App } from "@capacitor/app";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import type { PluginListenerHandle } from "@capacitor/core";
import { useGuideContext } from "@knocklabs/react";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { logError } from "@src/appV2/lib/analytics/log";
import { useEffect } from "react";

/**
 * Refetches Knock guides when the app resumes from the background.
 *
 * This hook listens to the Capacitor App "resume" event and triggers a fetch of the latest guides
 * from Knock. This ensures users see up-to-date content when returning to the app.
 */
export function useRefetchKnockGuidesOnResume() {
  const { client } = useGuideContext();

  useEffect(() => {
    let handle: PluginListenerHandle | undefined;
    let cancelled = false;

    async function registerListener() {
      try {
        handle = await App.addListener("resume", async () => {
          if (cancelled) {
            return;
          }

          try {
            await client.fetch();
          } catch (error) {
            if (cancelled) {
              return;
            }

            logError(APP_V2_APP_EVENTS.KNOCK_GUIDES_REFETCH_ON_RESUME_FAILED, { error });
          }
        });
      } catch (error) {
        if (!cancelled) {
          logError(APP_V2_APP_EVENTS.KNOCK_GUIDES_ATTACH_RESUME_LISTENER_FAILED, { error });
        }
      }
    }

    void registerListener();

    return () => {
      cancelled = true;
      void handle?.remove();
    };
  }, [client]);
}
